<div class="p-3">
    <div class="d-flex justify-content-between">
        <h3>Custom Commission for Level {{index + 1}} by Games</h3>
        <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>No</th>
                <th>Game</th>
                <th>Commission</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let game of games; let i = index">
                <td>{{i + 1}}</td>
                <td>{{game.title}}</td>
                <td>
                    <input type="number" class="form-control form-control-sm" [(ngModel)]="game.commission">
                </td>
            </tr>
        </tbody>
    </table>
    <div class="d-flex justify-content-end">
        <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
</div>